import React, { useState } from "react";
import { Link } from "react-scroll"
import { Menu } from "../styled-components/Menu";
import "../styles/navbar.css";
import { Loader } from "./Loader";
import { MdDarkMode } from "react-icons/md";
import { CiLight } from "react-icons/ci";
import { RiMenuFoldFill, RiCloseLine } from "react-icons/ri";
import { FloatingButton } from "../styled-components/FloatingButton";

export const Navbar = ({theme, toggleTheme}) => {
	const [openMenu, setOpenMenu] = useState(false);

	return (
		<nav>
			<Link to="home" offset={-100}>
				<div className="brand">
					<Loader />
					<h3>Sanjeet</h3>
				</div>
			</Link>

			<FloatingButton onClick={toggleTheme}>{theme === 'light' ? <MdDarkMode /> : <CiLight />}</FloatingButton>

			<div className="bigScreenNav">
				<ul className={"menus"}>
					<li className="menu__item">
						<Link to="home" offset={-100}>
							<Menu>Home</Menu>
						</Link>
					</li>

					<li className="menu__item">
						<Link to="about" offset={-100}>
							<Menu>About</Menu>
						</Link>
					</li>

					<li className="menu__item">
						<Link to="skills" offset={-100}>
							<Menu>Skills</Menu>
						</Link>
					</li>

					<li className="menu__item">
						<Link to="projects" offset={-100}>
							<Menu>Projects</Menu>
						</Link>
					</li>

					{/* <li className="menu__item">
						<Link to="experience" offset={-100}>
							<Menu>Experiences</Menu>
						</Link>
					</li> */}

					<li className="menu__item">
						{" "}
						<Link to="contacts" offset={-100}>
							<Menu>Contacts</Menu>
						</Link>
					</li>
				</ul>
			</div>

			<div className="smallScreenNav">
				<button onClick={() => setOpenMenu(true)}>
					<RiMenuFoldFill />
				</button>

				{openMenu && (
					<div className="menus__small">
						<ul className="small">
							<button onClick={() => setOpenMenu(false)}>
								<RiCloseLine />
							</button>

							<li className="menu__item">
								<Link
									data-aos="fade-up"
									onClick={() => setOpenMenu(false)}
									to="home"
									offset={-100}
								>
									<Menu>Home</Menu>
								</Link>
							</li>

							<li className="menu__item">
								<Link
									data-aos="fade-up"
									onClick={() => setOpenMenu(false)}
									to="about"
									offset={-100}
								>
									<Menu>About</Menu>
								</Link>
							</li>

							<li className="menu__item">
								<Link
									data-aos="fade-up"
									onClick={() => setOpenMenu(false)}
									to="skills"
									offset={-100}
								>
									<Menu>Skills</Menu>
								</Link>
							</li>

							<li className="menu__item">
								<Link
									data-aos="fade-up"
									onClick={() => setOpenMenu(false)}
									to="projects"
									offset={-100}
								>
									<Menu>Projects</Menu>
								</Link>
							</li>

							<li className="menu__item">
								<Link
									data-aos="fade-up"
									onClick={() => setOpenMenu(false)}
									to="contacts"
									offset={-100}
								>
									<Menu>Contacts</Menu>
								</Link>
							</li>
						</ul>
					</div>
				)}
			</div>
		</nav>
	);
};
